import Vue from 'vue'
import { FilterOption as IFilterOption } from 'services/api-service'

import withRender from './filter-options-group.html'
import './filter.scss'

export default withRender((Vue as any).extend({
  data() {
    return {}
  },
  props: {
    activeOptions: { type: Array },
    group: { type: String },
    name: { type: String },
    label: { type: String },
    options: { type: Array }
  },
  computed: {
    filterOptions() {
      return (this.options as Array<IFilterOption>).map((option) => {
        const isActive = (this.activeOptions as Array<IFilterOption>)
          .filter(activeOpt => activeOpt.value === option.value)
          .length > 0
        return { option, isActive }
      })
    }
  },
  methods: {
    optionClicked(option) {
      this.$emit('optionSelected', this.group, this.name, option)
    }
  }
}))



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!(webpack)-strip-block!./src/objects/menu/filter-options-group.ts